import axios from 'axios';
import * as endpoints from './const';

// const profile = {
//   success: true,
//   data: {
// 		id: 1,
// 		firstName: 'Peter',
// 		secondName: 'Butler',
// 		dob: '22/06/2016'
// 	},
//   error: {
//     errorCode: 0,
//     errorMessage: "string",
//     errors: {}
//   }
// };

class ProfileApi {
    // static getProfile() {
    // 	return new Promise((resolve, reject) => {
    // 		setTimeout(() => {
    // 			resolve(Object.assign([], profile));
    // 		}, 0);
    // 	});
    // }

    static changePassword(oldPassword, newPassword) {
        return axios
            .post(endpoints.PROFILE_CHANGE_PASSWORD, {
                oldPassword: oldPassword,
                newPassword: newPassword,
                confirmPassword: newPassword
            })
            .then(response => response.data)
            .then(data => {
                const { success, errors } = data;
                return {
                    success: success,
                    error: errors[0]
                };
            })
            .catch(error => {
                throw error;
            });
    }
}

export default ProfileApi;



// WEBPACK FOOTER //
// ./src/api/ProfileApi.js